'use client'

import { popularComparisonLinks } from '@/lib/comparisons/popular-links'
import type { CompareListedProduct } from '@/lib/supabase/get-compare-listed-products'

interface PopularComparisonDisclosureProps {
  products: CompareListedProduct[]
  title: string
}

// SSR includes every crawlable link, even while the native disclosure is closed.
// Only the small product list crosses the RSC boundary, rather than O(n²) JSX.
export const PopularComparisonDisclosure = ({ products, title }: PopularComparisonDisclosureProps) => {
  const comparisons = popularComparisonLinks(products)
  return (
    <section className="mx-auto w-full max-w-5xl px-4 py-8">
      <div className="overflow-hidden rounded-md border border-slate-200">
        <details className="group">
          <summary className="flex cursor-pointer list-none items-center justify-between bg-white p-5 text-[1.15rem] font-extrabold text-[#212529] hover:bg-slate-50 group-open:bg-[#e8f2f9] group-open:text-[#146fb0] [&::-webkit-details-marker]:hidden">
            {title}
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="ml-2 h-5 w-5 shrink-0 transition-transform group-open:rotate-180"
              aria-hidden="true"
            >
              <path d="M6 9l6 6 6-6" />
            </svg>
          </summary>
          <div className="border-t border-slate-200 bg-white p-5 text-[1.1rem] leading-normal">
            {comparisons.map((comparison) => (
              <div key={comparison.slug} className="pt-2">
                <a
                  href={`/hearing-aids/compare/${comparison.slug}`}
                  data-tracking="ignore"
                  className="text-lapis hover:underline"
                >
                  {comparison.label}
                </a>
              </div>
            ))}
          </div>
        </details>
      </div>
    </section>
  )
}
